<template>
  <div v-if="!isTs" class="wap-v">
    <Module ref="Module" class="mianv"
        :title="'交易规则'"
        :desc="'买入、卖出规则'"
        :nowrightArrow="true"
        :fetchCache="fetchCache"
        :fetchRequest="fetchRequest"
        :checkData="checkData"
        :isMainQueryError="getMainQueryError"
        :rightBtnEvent="clickMore"
        :moreEvent="clickMore">
          <div slot-scope="slotProps" class="mianv2">
            <div class="trade" v-for="(slotItem, index) in slotProps.list" :key="index">
              <!-- <div class="spline"></div> -->
              <div>
                <ProgressLine ref="ProgressLine"  @click="clickTrade">
                </ProgressLine>
                <div v-for="(item, index) in getlist(warningfo)" :key="index"
                class="linetext">
                  <p class="progress-desc">{{item}}</p>
                </div>
                <div class="trading-tags" @click="clickTags">
                  <div v-for="(tag, index) in slotItem.tradingTags" :key="index" class="tag-item">
                    <img src="@/assets/tag-choose.png" alt class="tag-icon" v-if="tag.enabled" />
                    <img src="@/assets/tag-unchoose.png" alt class="tag-icon" v-else />
                    <span :class="[tag.enabled ? 'tag-text' : 'tag-text-disabled']">
                      {{tag.text}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
    </Module>
  </div>
</template>

<script>
import Module from '@/components/Module.vue';
import ProgressLine from '@/components/ProgressLine.vue';
import JS from '@/base/JSTool';
import FundTypeSearch from '@/utils/FundTypeSearch';
import StoreManger from '@/utils/FundHQJHManger';
import {
  detailPushPage,
} from '@/utils/nativeBridge';

export default {
  name: 'FundTradingInfo',
  components: {
    Module,
    ProgressLine,
  },
  props: {
  },
  computed: {
    isExchangeFund() {
      return FundTypeSearch.isExchangeFund(this.fundType);
    },
    isNewFund() {
      return FundTypeSearch.isNewFund(this.fundType);
    },
    isHQBFund() {
      return FundTypeSearch.isHQBFund(this.fundType);
    },
  },
  data() {
    return {
      tipList: [],
      isTs: false,
      warningfo: {},
      tradingTags: [
        {
          text: '活期宝支付',
          enabled: true,
        },
        {
          text: '极速回活期宝',
          enabled: false,
        },
        {
          text: '超级转换',
          enabled: true,
        },
      ],
    };
  },
  created() {
  },
  mounted() {
    // this.render();
  },
  methods: {
    mainQueryError() {
      if (this.$refs.Module) {
        this.$refs.Module.showMainError();
      }
    },
    render() {
      this.warningfo = StoreManger.getFundJJTX();
      this.fundCode = this.$store.state.native.fund.fundCode;
      this.fundType = this.$store.state.native.fund.fundType;
      const baseInfo = StoreManger.getFundJJXQ();
      if (baseInfo) {
        if (baseInfo.ISSALES === '0' || baseInfo.ISSALES === '--') {
          this.isTs = true;
        } else {
          this.isTs = false;
        }
      } else {
        this.isTs = true;
      }
      if (this.isTs) {
        return;
      }
      const refs = this.$refs;
      if (refs.ProgressLine && refs.ProgressLine[0]) {
        refs.ProgressLine[0].render();
      }
      const fundId = StoreManger.getFundJJTX();
      const conlist = JS.fetchArray(fundId, 'TRADEMARKLIST');
      this.tipList = conlist;
      this.$nextTick(() => {
        this.$refs.Module.start();
      });
    },
    getlist(item) {
      if (item) {
        const fundId = StoreManger.getFundJJTX();
        const conlist = JS.fetchArray(fundId, 'TRADEMARKLIST');
        return conlist;
      }
      const fundId = StoreManger.getFundJJTX();
      const conlist = JS.fetchArray(fundId, 'TRADEMARKLIST');
      return conlist;
    },
    getMainQueryError() {
      const fundinfo = StoreManger.getFundJJXQ();
      if (!fundinfo) {
        return true;
      }
      if (!fundinfo.FCODE) {
        return true;
      }
      return false;
    },
    fetchCache() {
      const fundinfo = StoreManger.getFundJJXQ();
      this.handleData(fundinfo);
      return [{
        tipList: this.tipList,
        tradingTags: this.tradingTags,
      }];
    },
    fetchRequest() {
      return new Promise((resolve, reject) => {
        reject();
      });
    },
    checkData(data) {
      return (data && Object.prototype.toString.call(data) === '[object Array]' && data.length > 0);
    },
    handleData(item) {
      const fetch = (key) => {
        const res = JS.fetchString(item, key);
        return res || '--';
      };
      // const BUY = fetch('BUY') === '1';
      const STKTOCASH = fetch('STKTOCASH') === '1';
      const STKEXCHG = fetch('STKEXCHG') === '1';
      const FUNDEXCHG = fetch('FUNDEXCHG') === '1';
      const CASHBUY = fetch('CASHBUY') === '1';
      if (this.isHQBFund) {
        this.tradingTags = [
          {
            text: '买基金',
            enabled: item.BUY,
          },
          {
            text: '极速取现，最快1秒到账',
            enabled: STKTOCASH,
          },
        ];
      } else {
        this.tradingTags = [
          {
            text: '活期宝支付',
            enabled: CASHBUY,
          },
          {
            text: '极速回活期宝',
            enabled: STKTOCASH,
          },
          {
            text: '超级转换',
            enabled: STKEXCHG || FUNDEXCHG,
          },
        ];
      }
    },
    clickTags() {
      // const domin = fund.getUrlConfigSync({
      //   remoteKey: '',
      //   localKey: 'help_center',
      // });
      // ❌ 缺少此域名配置
      // https://helpmob.1234567.com.cn/
      // https://helpmobtest.1234567.com.cn/
      const domin = 'https://helpmob.1234567.com.cn/';
      detailPushPage({
        type: 2,
        url: `${domin}m/q_890.html?&rand=${Math.floor(Math.random() * 100)}`,
      });
    },
    clickTrade() {
      this.clickMore();
    },
    clickMore() {
      const baseInfo = StoreManger.getFundJJXQ();
      const name = StoreManger.getFundJJXQNAME(baseInfo);
      // #if EXECUTION_ENV == 'web'
      // this.wxmobuy();
      // eslint-disable-next-line no-undef
      const webPlatf = multi.$system.webPlatform;
      if (webPlatf === 'dfcf') {
        detailPushPage({
          appId: '516939c37bdb4ba2b1138c50cf69a2e1',
          url: '/pages/FundTradeInfo',
          params: {
            fundcode: this.fundCode,
            fundname: name,
          },
        }, {
          dfcf: {
            url: `https://trademob2.1234567.com.cn/funddetail.html#page=fundfl&code=${this.fundCode}`,
            openNewWindow: true,
          }, // 东财内嵌h5环境跳转地址, 可以传OBJECT2格式的参数
        });
        return;
      }
      // #endif
      detailPushPage({
        appId: '516939c37bdb4ba2b1138c50cf69a2e1',
        url: '/pages/FundTradeInfo',
        params: {
          fundcode: this.fundCode,
          fundname: name,
        },
      });
      this.reportMonitor({
        eventName: 'pz.xx.buy.more',
      });
    },
  },
};
</script>

<style scoped>
.mianv{
  margin-left: 24px;
  margin-right: 24px;
  background: #fff;
  border-radius: 12px;
  margin-bottom: 24px;
}
.mianv2 {
  background-color: white;
  margin-left: 24px;
  margin-right: 24px;
  background: #fff;
  border-radius: 12px;
}
.trade{
  background-color: white;
  /* border-top: 1px solid #EEEEEE; */
}
.spline{
  margin: 0px 30px;
}
.linetext{
  margin: 0 0px;
}
.progress-desc {
  font-family: PingFangSC-Regular;
  font-size: 28px;
  text-align: justify;
  padding-top: 14px;
  padding-bottom: 16px;
  color: #666666;
  line-height: 46px;
}

.trading-tags {
  /* border-top: 1px solid #eeeeee; */
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 30px 0px 40px 0px;
  border-radius: 12px;
}

.tag-item {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.tag-icon {
  width: 28px;
  height: 28px;
  margin-right: 5px;
  align-items: center;
}

.tag-text {
  font-family: PingFangSC-Regular;
  font-size: 28px;
  color: #ff4400;
  align-items: center;
}

.tag-text-disabled {
  font-family: PingFangSC-Regular;
  font-size: 28px;
  color: #999999;
  align-items: center;
}
</style>
